import { render } from "./HouseIcon.vue?vue&type=template&id=4c42042b"
import script from "./HouseIcon.vue?vue&type=script&lang=js"
export * from "./HouseIcon.vue?vue&type=script&lang=js"

import exportComponent from "/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__